__turbopack_context__.v({
  "actions": "TasksFeedNav-module-scss-module__lwzrVq__actions",
  "checkList": "TasksFeedNav-module-scss-module__lwzrVq__checkList",
  "checkListSheet": "TasksFeedNav-module-scss-module__lwzrVq__checkListSheet",
  "checkbox": "TasksFeedNav-module-scss-module__lwzrVq__checkbox",
  "checkboxChecked": "TasksFeedNav-module-scss-module__lwzrVq__checkboxChecked",
  "checkboxIcon": "TasksFeedNav-module-scss-module__lwzrVq__checkboxIcon",
  "chevron": "TasksFeedNav-module-scss-module__lwzrVq__chevron",
  "chevronOpen": "TasksFeedNav-module-scss-module__lwzrVq__chevronOpen",
  "chip": "TasksFeedNav-module-scss-module__lwzrVq__chip",
  "chipActive": "TasksFeedNav-module-scss-module__lwzrVq__chipActive",
  "chipIcon": "TasksFeedNav-module-scss-module__lwzrVq__chipIcon",
  "chipSoon": "TasksFeedNav-module-scss-module__lwzrVq__chipSoon",
  "chipWrap": "TasksFeedNav-module-scss-module__lwzrVq__chipWrap",
  "chips": "TasksFeedNav-module-scss-module__lwzrVq__chips",
  "count": "TasksFeedNav-module-scss-module__lwzrVq__count",
  "divider": "TasksFeedNav-module-scss-module__lwzrVq__divider",
  "iconButton": "TasksFeedNav-module-scss-module__lwzrVq__iconButton",
  "menu": "TasksFeedNav-module-scss-module__lwzrVq__menu",
  "menuGroup": "TasksFeedNav-module-scss-module__lwzrVq__menuGroup",
  "menuGroupLabel": "TasksFeedNav-module-scss-module__lwzrVq__menuGroupLabel",
  "menuItem": "TasksFeedNav-module-scss-module__lwzrVq__menuItem",
  "menuItemAll": "TasksFeedNav-module-scss-module__lwzrVq__menuItemAll",
  "menuItemCheck": "TasksFeedNav-module-scss-module__lwzrVq__menuItemCheck",
  "menuItemIcon": "TasksFeedNav-module-scss-module__lwzrVq__menuItemIcon",
  "menuItemLabel": "TasksFeedNav-module-scss-module__lwzrVq__menuItemLabel",
  "menuItemSelected": "TasksFeedNav-module-scss-module__lwzrVq__menuItemSelected",
  "mobileActions": "TasksFeedNav-module-scss-module__lwzrVq__mobileActions",
  "popover": "TasksFeedNav-module-scss-module__lwzrVq__popover",
  "root": "TasksFeedNav-module-scss-module__lwzrVq__root",
  "sheet": "TasksFeedNav-module-scss-module__lwzrVq__sheet",
  "sheetApply": "TasksFeedNav-module-scss-module__lwzrVq__sheetApply",
  "sheetBody": "TasksFeedNav-module-scss-module__lwzrVq__sheetBody",
  "sheetClear": "TasksFeedNav-module-scss-module__lwzrVq__sheetClear",
  "sheetFooter": "TasksFeedNav-module-scss-module__lwzrVq__sheetFooter",
  "sheetHandle": "TasksFeedNav-module-scss-module__lwzrVq__sheetHandle",
  "sheetOverlay": "TasksFeedNav-module-scss-module__lwzrVq__sheetOverlay",
  "sheetTitle": "TasksFeedNav-module-scss-module__lwzrVq__sheetTitle",
  "soonBadge": "TasksFeedNav-module-scss-module__lwzrVq__soonBadge",
  "view": "TasksFeedNav-module-scss-module__lwzrVq__view",
  "viewActive": "TasksFeedNav-module-scss-module__lwzrVq__viewActive",
  "views": "TasksFeedNav-module-scss-module__lwzrVq__views",
});
